// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DiffFilledSvg from "@ant-design/icons-svg/es/asn/DiffFilled";
import AntdIcon from '../components/AntdIcon';

var DiffFilled = function DiffFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DiffFilledSvg
  }));
};

DiffFilled.displayName = 'DiffFilled';
export default React.forwardRef(DiffFilled);